<project-item>
 <!-- <div class="contents_block margin-spacing-2_bottom" onclick={(e)=>detail(props.project.project_id)}> -->
  <div class="contents_block margin-spacing-2_bottom">
    
    <div class="container_project-info margin-spacing-1_bottom">
      <span class="status_label project_status_label-{props.project.state} margin-spacing-1_right"></span>
      <ul class="information_list">
        <li class="information_list-item state_line_item"><span class="information_list-item-title">プロジェクトID:</span>{props.project.project_id}</li>
      </ul><!--/.information_list-->
    </div><!--/.container_project-info-->

    <h2 class="matter_heading margin-spacing-2_bottom">
      <a onclick={(e)=>detail(props.project.project_id)}>{props.project.title}</a>
    </h2>
    <p style="font-size: 1.125rem;margin-bottom: 1rem;" if={props.project.description != ""}>
      <span style="color: #B5B5B5">お仕事に関するコメント：</span>{props.project.description}
    </p>

    <ul class="scope_list margin-spacing-2_bottom" if={props.project.working_scope_names.length >= 1}>
      <li class="scope_list-item" each={working_scope_name in props.project.working_scope_names}><span class="skill_label">{working_scope_name}</span></li>
    </ul>

    <ul class="information_list margin-spacing-1_bottom">
      <li class="information_list-item">
        <span class="information_list-item-title">仕事内容:</span>
        <span each={work_type_name in props.project.work_type}>{work_type_name}</span>
      </li>
      <li class="information_list-item">
        <span class="information_list-item-title">ジャンル・テーマ:</span>
        <span each={genre_name in props.project.text_content_genres}>{genre_name}</span>
      </li>
      <li class="information_list-item">
        <span class="information_list-item-title">掲載予定媒体:</span>
        <span each={target_media_name in props.project.target_medias}>{target_media_name}</span>
      </li>
    </ul><!--/.information_list-->

    <ul class="information_list margin-spacing-1_bottom">
      <li class="information_list-item"><span class="information_list-item-title">報酬総額:</span>
        <span class="notice"><number-format number={props.project.reward_amount} /></span>
        <span class="note">円</span>
      </li>

      <li class="information_list-item"><span class="information_list-item-title">1制作物の報酬単価:</span>
        <span class="notice"><number-format number={props.project.reward_unit_price} /></span>
        <span class="note">円</span>
      </li>

      <li class="information_list-item">
        <span class="information_list-item-title">制作物の数:</span>{props.project.volume}{di.Edilent.cTypeProps(props.project.text_content_type_group_ids).num}
      </li>
      <li class="information_list-item" if={!di.Edilent.isNonCharContentType(props.project.text_content_type_group_ids)}>
        <span class="information_list-item-title">{di.Edilent.cTypeProps(props.project.text_content_type_group_ids).title}:</span><number-format number={props.project.char_count_per_post} />{di.Edilent.cTypeProps(props.project.text_content_type_group_ids).unit}
      </li>

      <li class="information_list-item"><span class="information_list-item-title">進捗状況:</span>
        （
        検証待ち：<span class="notice">{props.project.wait_verification_num}</span> /
        修正依頼：<span class="notice">{props.project.wait_retake_num}</span> /
        納品済：<span class="notice">{props.project.delivered_num}</span>）
      </li>
    </ul><!--/.information_list-->

    <p if={props.project.company_type==2} style="font-size: 1.15rem">
      ※源泉が引かれる前の⾦額が表⽰されております。
    </p>

    <div class="container_schedule-info">
      <ul class="information_list">
        <li class="information_list-item"><span class="information_list-item-title">初回提出期限:</span>
        <span class="notice">{props.project.delivery_hope_date}</span>
        </li>
      </ul><!--/.information_list-->
      <div class="suppliers">{props.project.client_name}</div>
    </div><!--/.container_schedule-info-->

  </div><!--/.contents_block-->

<script>
  import di from "dependeny-injection";
  export default {
    di: di,
    detail(id) {
      di.router.push(`/project/detail/${id}`);
    }
  }
</script>
</project-item>
